"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { DateTimeFields } from "~/app/(site)/search/_components/DateTimeFields";
import { Button } from "~/components/ui/button";
interface MobileDateTimeModalProps {
  open: boolean;
  onClose: () => void;
  startsAt: string;
  endsAt: string;
  onStartsAtChange: (v: string) => void;
  onEndsAtChange: (v: string) => void;
  now: Date;
  /** The destination's IANA zone — see `DateTimeFields.timeZone`. */
  timeZone?: string | null;
}
export function MobileDateTimeModal(t0) {
  const $ = _c(22);
  const {
    open,
    onClose,
    startsAt,
    endsAt,
    onStartsAtChange,
    onEndsAtChange,
    now,
    timeZone
  } = t0;
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (!open || window.innerWidth >= 768) {
        return;
      }
      document.body.style.overflow = "hidden";
      return _temp;
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!open || typeof document === "undefined") {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowLeft className="h-5 w-5" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClose) {
    t4 = <button type="button" onClick={onClose} aria-label="Back" className="-ml-1 rounded-full p-1.5 text-[var(--ink-60)] transition-colors hover:bg-[var(--ink-05)] hover:text-[var(--ink)]">{t3}</button>;
    $[4] = onClose;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="text-[17px] font-semibold text-[var(--ink)]">When do you need to park?</h2>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex shrink-0 items-center gap-3 border-b border-[var(--ink-10)] px-4 py-4">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== endsAt || $[10] !== now || $[11] !== onEndsAtChange || $[12] !== onStartsAtChange || $[13] !== startsAt || $[14] !== timeZone) {
    t7 = <div className="flex-1 px-4 py-6"><DateTimeFields startsAt={startsAt} endsAt={endsAt} onStartsAtChange={onStartsAtChange} onEndsAtChange={onEndsAtChange} now={now} timeZone={timeZone} /></div>;
    $[9] = endsAt;
    $[10] = now;
    $[11] = onEndsAtChange;
    $[12] = onStartsAtChange;
    $[13] = startsAt;
    $[14] = timeZone;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onClose) {
    t8 = <div className="shrink-0 border-t border-[var(--ink-10)] px-4 py-4"><Button type="button" variant="primary" size="md" className="w-full" onClick={onClose}>Apply</Button></div>;
    $[16] = onClose;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = createPortal(<div data-mobile-datetime-modal={true} className="fixed inset-0 z-[200] flex flex-col bg-[var(--color-surface)] md:hidden">{t6}{t7}{t8}</div>, document.body);
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp() {
  document.body.style.overflow = "";
}